/**
 * Aviso de versao nova.
 *
 * Aparece em baixo, por cima da barra, e fica la ate ela decidir. Nunca
 * desaparece sozinho e nunca recarrega sozinho: se ela estiver a meio de
 * registrar uma despesa, recarregar apagava-a.
 */
import { BigButton } from '@flos/ui';

export interface UpdatePromptProps {
  visible: boolean;
  onUpdate: () => void;
  onDismiss: () => void;
}

export function UpdatePrompt({ visible, onUpdate, onDismiss }: UpdatePromptProps) {
  if (!visible) return null;

  return (
    <div className="app-update" role="status" aria-live="polite">
      <p className="app-update__text">
        <span className="flos-icon" aria-hidden="true">
          ✨
        </span>{' '}
        Há uma versão nova. Toque para atualizar.
      </p>
      <div className="app-update__actions">
        <BigButton onClick={onUpdate} size="md" icon="🔄">
          Atualizar agora
        </BigButton>
        <BigButton onClick={onDismiss} size="md" variant="ghost">
          Agora não
        </BigButton>
      </div>
    </div>
  );
}
